import { useBreakpoint } from '@vivino/js-react-common-ui';
import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import Slider from 'vivino-js/utilities/Slider';

import { Col, Row } from 'vivino-ui/components/Grid';

import TasteNote from '../TasteNote';
import styles from './tasteNotes.scss';

export const MAX_CHARS = 23;
export const NUMBER_OF_WORDS = 3;
const NUMBER_OF_NOTES = 3;

const TRANSLATIONS_PATH = 'components.shared.taste_notes';
const TRANSLATIONS = {
  showAll: `${TRANSLATIONS_PATH}.show_all`,
  whatPeopleTalkAbout: `${TRANSLATIONS_PATH}.what_people_talk_about`,
};

const TasteNotes = ({ notes, wineId, vintageYear }) => {
  const { t } = useI18N();
  const { isMobile, isTablet } = useBreakpoint();
  const [showAll, setShowAll] = useState(false);

  const validNotes = notes?.filter(
    (note) =>
      note.primary_keywords && note.primary_keywords.length > 0 && note?.stats?.count && note.group
  );

  const handleToggleShowAll = (e) => {
    e.preventDefault();
    setShowAll(!showAll);
  };

  if (notes.length === 0) {
    return null;
  }

  if (!isMobile) {
    return (
      <Row>
        <Slider pageSize={isTablet ? 2 : 3} grid showControlsOnAllDevices>
          {validNotes.map((note) => (
            <Col desktop={4} tablet={6} key={note.group}>
              <TasteNote note={note} wineId={wineId} vintageYear={vintageYear} />
            </Col>
          ))}
        </Slider>
      </Row>
    );
  } else {
    const shownNotes = validNotes.slice(0, NUMBER_OF_NOTES);
    const restNotes = validNotes.slice(NUMBER_OF_NOTES);

    return (
      <>
        {shownNotes.map((note) => (
          <TasteNote note={note} key={note.group} wineId={wineId} vintageYear={vintageYear} />
        ))}
        <AnimateHeight duration={300} height={showAll ? 'auto' : 0}>
          {restNotes.map((note) => (
            <TasteNote note={note} key={note.group} wineId={wineId} vintageYear={vintageYear} />
          ))}
        </AnimateHeight>
        {!showAll && (
          <a className={styles.toggleShowAll} onClick={handleToggleShowAll}>
            {t(TRANSLATIONS.showAll)}
          </a>
        )}
      </>
    );
  }
};

TasteNotes.propTypes = {
  notes: PropTypes.array.isRequired,
  vintageYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  wineId: PropTypes.number,
};

export default TasteNotes;
